<template>
  <div>
    <p v-if="searchItems && searchItems.length" class="screening-content">
      <span>{{ $t('Sop.ScreeningContent') }}</span>
      <template v-for="(item,index) in searchItemsCopy">
        <template v-if="item.key === 'lob'">
          <el-tag :key="`${item.key}-${index}`" closable @close="()=>handleTagClose(item.key)">
            {{ `${$t(item.label)}: ${item.name}` }}
          </el-tag>
        </template>
        <el-tag v-else-if="item.key === 'trackDetailIds'" :key="`${item.key}-${index}`" closable @close="()=>handleTagClose(item.key)">
          <el-tooltip class="item" effect="dark" :content="`${$t(item.label)}: ${item.name}`" placement="bottom">
            <span class="track-short-show">{{ `${$t(item.label)}: ${item.name}` }}</span>
          </el-tooltip>
        </el-tag>
        <el-tag v-else-if="item.key === 'warnLevel'" :key="`${item.key}-${index}`" closable @close="()=>handleTagClose(item.key)">{{ `${$t(item.label)}: ${getWarningText(item.value)}` }}</el-tag>
        <el-tag v-else-if="Array.isArray(item.value)" :key="`${item.key}-${index}`" closable @close="()=>handleTagClose(item.key)">{{ `${$t(item.label)}: ${item.value.join('~')}` }}</el-tag>
        <el-tag v-else :key="`${item.key}-${index}`" closable @close="()=>handleTagClose(item.key)">{{ `${$t(item.label)}: ${item.value}` }}</el-tag>
      </template>
    </p>
    <cargo-ag-grid
      :config-module="configModule"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
    />
    <div class="pre-warning-footer">
      <div class="left">
        <el-button v-if="type === 'pre'" key="pre" :type="hasSelected?'primary': 'info'" plain :disabled="!hasSelected" @click="()=>handleOperate(1)">{{ $t('Sop.ignoreSelected') }}</el-button>
        <el-button v-else key="ignore" :type="hasSelected?'primary': 'info'" plain :disabled="!hasSelected" @click="()=>handleOperate(0)">{{ $t('Sop.restoreSelected') }}</el-button>
      </div>
      <cargo-pagination
        :total="pagination.total"
        :page.sync="pagination.pageNum"
        :limit.sync="pagination.pageSize"
        layout="total, prev, pager, next"
        @pagination="fetchData"
      />
    </div>
    <filter-dialog ref="filterDialog" :visible="showFilter" @close="handleCloseFilter" @search="handleSearch" />
  </div>
</template>

<script>
import FilterDialog from './FilterDialog'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { STATETYPES } from '@/class/cargo/model/parameters/TrackingConstants'
import RouterAndPrintRenderer from '@/components/Cargo/Common/routerAndPrintRenderer'
import lodash from 'lodash'

export default {
  name: 'PreWarningList',
  components: { FilterDialog },
  props: {
    type: {
      type: String,
      default: () => 'pre'
    },
    showFilter: {
      type: Boolean,
      default: () => false
    },
    configModule: {
      type: String,
      default: () => null
    },
    api: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      gridOptions: {
        rowSelection: 'multiple',
        onRowSelected: (params) => {
          this.selectedRows = params.api.getSelectedRows()
        },
        frameworkComponents: {
          RouterAndPrintRenderer
        }
      },
      rowData: [],
      columnDefs: [
        {
          headerName: '', width: 32, checkboxSelection: true, sortable: false, suppressMenu: true,
          suppressSizeToFit: true, resizable: false, lockVisible: true,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessType'),
          field: 'lob',
          colId: 'lob',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Sop.nodeName'),
          field: 'nodeName',
          colId: 'nodeName',
          width: 100
        },
        {
          headerName: this.$t('Sop.nodeState'),
          field: 'nodeState',
          colId: 'nodeState',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.BusinessNo'),
          field: 'jobNo',
          colId: 'jobNo',
          width: 100,
          cellRendererSelector: (params) => {
            return ColumnUtils.routeNameByJobLobFun(params, 'lob', 'jobNo', false)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_MblNo'),
          field: 'mbl',
          colId: 'mbl',
          width: 100
        },
        {
          headerName: this.$t('Sop.warningLevel'),
          field: 'warningLevel',
          colId: 'warningLevel',
          width: 100,
          valueFormatter: params => {
            return this.getWarningText(params.value)
          }
        },
        {
          headerName: 'ETD',
          field: 'etd',
          colId: 'etd',
          width: 150
        },
        {
          headerName: 'ETA',
          field: 'eta',
          colId: 'eta',
          width: 150
        },
        {
          headerName: this.$t('Sop.warningAt'),
          field: 'createTime',
          colId: 'createTime',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChineseFirstVesselName'),
          field: 'vessel',
          colId: 'vessel',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_VoyageFlight'),
          field: 'voyageFlight',
          colId: 'voyageFlight',
          width: 100
        },
        {
          headerName: this.$t('Sop.warningContent'),
          field: 'content',
          colId: 'content',
          width: 400
        }
      ],
      pagination: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      searchItems: null,
      searchItemsTxt: '',
      searchItemsCopy: null,
      selectedRows: null,
      loading: null
    }
  },
  computed: {
    hasSelected() {
      return this.selectedRows && this.selectedRows.length
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    officeId() {
      return this.$store.getters.currentOfficeId
    }
  },
  watch: {
    officeId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fetchData()
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = getLoading('preWarning')
      const { list } = this.api
      const searchParams = {}
      if (this.searchItems) {
        this.searchItems.forEach(item => {
          switch (item.key) {
            case 'etd':
              searchParams.etdStartTime = item.value[0] + ' 00:00:00' || ''
              searchParams.etdEndTime = item.value[1] + ' 23:59:59' || ''
              break
            case 'eta':
              searchParams.etaStartTime = item.value[0] + ' 00:00:00' || ''
              searchParams.etaEndTime = item.value[1] + ' 23:59:59' || ''
              break
            case 'createTime':
              searchParams.warnStartTime = item.value[0] + ' 00:00:00' || ''
              searchParams.warnEndTime = item.value[1] + ' 23:59:59' || ''
              break
            default:
              searchParams[item.key] = item.value
              break
          }
        })
      }
      const params = {
        branchId: this.$store.getters.currentOfficeId,
        page: this.pagination.pageNum,
        ...searchParams
      }
      list(params).then(res => {
        this.rowData = res.data.list || []
        this.pagination.total = Number(res.data.total) || 0
      }).finally(() => {
        this.loading.close()
      })
    },
    handleOperate(option) {
      const recordIds = this.selectedRows.map(row => row.uuid)
      const { operate } = this.api
      operate({ ids: recordIds, ignoreFlag: !!option }).then(() => {
        this.selectedRows = null
        this.fetchData()
      })
    },
    handleCloseFilter() {
      this.$emit('update:showFilter', false)
    },
    handleSearch(val, config) {
      this.searchItems = val
      this.searchItemsTxt = config
      this.searchItemsCopy = lodash.cloneDeep(val)
      this.$emit('update:showFilter', false)
      this.$nextTick(() => {
        this.pagination.pageNum = 0
        this.fetchData()
      })
    },
    handleTagClose(e) {
      let deleteLob
      if (e === 'lob') {
        deleteLob = true
      }
      this.searchItems.forEach((item, index) => {
        if (item.key === 'trackDetailIds' && deleteLob) {
          this.searchItems.splice(index, 1)
        }
        if (item.key === e) {
          item.value = ''
        }
      })
      this.fetchData()
      this.searchItemsCopy.forEach((item, index) => {
        if (item.key === 'trackDetailIds' && deleteLob) {
          this.searchItemsCopy.splice(index, 1)
        }
        if (item.key === e) {
          this.searchItemsCopy.splice(index, 1)
        }
      })
      const tempArr = JSON.parse(this.searchItemsTxt)

      tempArr.map((eve) => {
        if (eve.key === 'trackDetailIds' && deleteLob) {
          eve.value = []
          eve.name = ''
        }
        if (eve.key === e) {
          if (typeof (eve.value) !== 'object') {
            eve.value = ''
          } else {
            eve.value = []
          }
          if (eve.name) {
            eve.name = ''
          }
        }
      })
      this.searchItemsTxt = JSON.stringify(tempArr)
      this.$refs.filterDialog.configChange(this.searchItemsTxt)
    },
    getNodeState(value) {
      const stateTypes = Array.from(STATETYPES)
      const state = stateTypes.find(item => item.code === value)
      if (!state) {
        return ''
      }
      return this.isZh ? state.chineseName : state.englishName
    },
    getWarningText(value) {
      const levels = [
        {
          chineseName: '最高',
          code: 0,
          englishName: 'Highest'
        },
        {
          chineseName: '高',
          code: 1,
          englishName: 'High'
        },
        {
          chineseName: '中',
          code: 2,
          englishName: 'Medium'
        },
        {
          chineseName: '低',
          code: 3,
          englishName: 'Low'
        }
      ]
      const lev = levels.find(item => item.code === value)
      if (!lev) {
        return ''
      }
      return this.isZh ? lev.chineseName : lev.englishName
    }
  }
}
</script>

<style lang="scss" scoped>
.screening-content{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  .el-tag{
    max-width: 320px;
    box-sizing: border-box;
    padding-right: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
    .track-short-show{
      max-width: 20px;
    }
    /deep/ .el-tag__close{
      position: absolute;
      right: 0;
      top: 2px;
    }
  }
}

.pre-warning-footer{
  display: flex;
  justify-content: space-between;
  padding-top: 5px;
  .left{
    display: flex;
    align-items: center;
  }
}
</style>
